/* eslint-disable react/prop-types */
import React, { useMemo } from 'react';
import {
  Col,
  Row,
  Modal,
  Typography,
  Button,
  Tooltip,
  Grid,
} from 'antd';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { getModelPermission } from 'utils/permission/index';
import { useDispatch, useSelector } from 'react-redux';
import { SET_VISIBLE_MODAL_CORTE } from 'store/reducers/app';
import useCorte from 'hooks/useCorte';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const ModalCorte = () => {
  const { corteSinCerrar } = useCorte();
  const history = useHistory();
  const screen = useBreakpoint();
  const dispatch = useDispatch();
  const visible = useSelector(({ app }) => app.visibleModalCorte);
  const cortePermission = useMemo(() => getModelPermission('corte'));

  const onCancel = () => {
    dispatch({
      type: SET_VISIBLE_MODAL_CORTE,
      payload: false,
    });
  };

  const CerrarCorteControl = ({ disabled }) => (
    <Button
      icon={<ArrowRightOutlined />}
      type="link"
      onClick={() => {
        onCancel();
        history.push('/recaudacion/corte/cerrar-corte/');
      }}
      disabled={disabled}
    >
      {screen.md && 'Cerrar Corte'}
    </Button>
  );

  const AbrirCorteControl = ({ disabled }) => (
    <Button
      icon={<ArrowLeftOutlined />}
      type="link"
      onClick={() => {
        onCancel();
        history.push('/recaudacion/corte/abrir-corte/');
      }}
      disabled={disabled}
    >
      {screen.md && 'Abrir Corte'}
    </Button>
  );

  const CerrarModalControl = () => (
    <Button
      icon={<ArrowRightOutlined />}
      type="link"
      onClick={() => onCancel()}
    >
      {screen.md && 'Continuar sin Corte'}
    </Button>
  );

  const ValidatePermissionCerrarCorte = () => ((cortePermission.view && cortePermission.change) ? (
    <CerrarCorteControl />
  ) : (
    <Tooltip title="No tienes los permisos necesarios para cerrar corte.">
      <CerrarCorteControl disabled />
    </Tooltip>
  ));

  const ValidatePermissionAbrirCorte = () => ((cortePermission.view && cortePermission.change) ? (
    <AbrirCorteControl />
  ) : (
    <Tooltip placement="top" title="No tienes los permisos necesarios para Abrir corte.">
      <AbrirCorteControl disabled />
    </Tooltip>
  ));

  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      title={(
        <>
          <Row justify="space-between">
            <Col>
              Corte
            </Col>
            <Col>
              {!corteSinCerrar ? (
                <>
                  <ValidatePermissionAbrirCorte />
                  <CerrarModalControl />
                </>
              ) : (
                <ValidatePermissionCerrarCorte />
              )}
            </Col>
          </Row>
        </>
      )}
      onCancel={onCancel}
      forceRender
      centered
    >
      <Col style={{ textAlign: 'center' }}>
        <Text>
          {corteSinCerrar
            ? 'Tiene un corte sin cerrar'
            : 'No se encontró ningún corte abierto'}
        </Text>
      </Col>
    </Modal>
  );
};

export default ModalCorte;
